import { NgModule } from '@angular/core';
import { CustomResourcePanelDirective } from '@shared/directives/custom-resource-panel.directive';
import { NgxCodeJarComponent } from 'ngx-codejar';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { CalcResultItemComponent } from '../calculators/components/calc-result-item/calc-result-item.component';
import { ChatResourcesService } from '../chat-page/services/chat-resources.service';
import { PreviewModule } from '../preview/preview.module';
import { FilesViewItemComponent } from '../results-views/files-view-item/files-view-item.component';
import { MailViewItemComponent } from '../results-views/mail/mail-view-item/mail-view-item.component';
import { PeopleViewItemComponent } from '../results-views/people/people-view-item/people-view-item.component';
import { RelevantPeopleItemComponent } from '../results-views/relevant-people/relevant-people-item/relevant-people-item.component';
import { AnswerActionsComponent } from './components/answer-actions/answer-actions.component';
import { AnswerCodeHeaderModule } from './components/answer-code-header/answer-code-header.module';
import { BrowserBookmarkItemComponent } from './components/browser-bookmark-item/browser-bookmark-item.component';
import { BrowserTabItemComponent } from './components/browser-tab-item/browser-tab-item.component';
import { ConnectPcComponent } from './components/connect-pc/connect-pc.component';
import { CreateGoLinkItemComponent } from './components/create-go-link-item/create-go-link-item.component';
import { DragAndDropComponent } from './components/drag-and-drop/drag-and-drop.component';
import { EmbedItemComponent } from './components/embed-item/embed-item.component';
import { ErrorItemComponent } from './components/error-item/error-item.component';
import { AnswerFeedbackComponent } from './components/feedback-popup/answer-feedback/answer-feedback.component';
import { FeedbackPopupComponent } from './components/feedback-popup/feedback-popup.component';
import { FeedbackReasonOptionsComponent } from './components/feedback-popup/feedback-reason-options/feedback-reason-options.component';
import { GalleryGroupComponent } from './components/gallery-group/gallery-group.component';
import { GalleryViewComponent } from './components/gallery-view/gallery-view.component';
import { GoToItemComponent } from './components/go-to-item/go-to-item.component';
import { LocalActionsItemComponent } from './components/local-actions-item/local-actions-item.component';
import { ParamSelectionsItemComponent } from './components/param-selection/param-selections-item/param-selections-item.component';
import { ParamSelectionsComponent } from './components/param-selection/param-selections.component';
import { QueryItemComponent } from './components/query-item/query-item.component';
import { RecentSearchItemComponent } from './components/recent-search-item/recent-search-item.component';
import { ResourcePanelPopupComponent } from './components/resource-panel-popup/resource-panel-popup.component';
import { ResourcePanelComponent } from './components/resource-panel/resource-panel.component';
import { ResourceRedirectorComponent } from './components/resource-redirector/resource-redirector.component';
import { ResultAnnotationComponent } from './components/result-annotation/result-annotation.component';
import { ResultsAnswerItemComponent } from './components/result-answer-item/result-answer-item.component';
import { ResultAttachmentPopupComponent } from './components/result-attachment/result-attachment-popup/result-attachment-popup.component';
import { ResultAttachmentComponent } from './components/result-attachment/result-attachment.component';
import { ResultBadgeComponent } from './components/result-badge/result-badge.component';
import { ResultBulletPartComponent } from './components/result-bullet/result-bullet-part/result-bullet-part.component';
import { ResultBulletComponent } from './components/result-bullet/result-bullet.component';
import { ResultCodeBlockComponent } from './components/result-code-block/result-code-block.component';
import { ResultFolderComponent } from './components/result-folder/result-folder.component';
import { ResultsHeaderComponent } from './components/result-header/result-header.component';
import { ResultItemComponent } from './components/result-item/result-item.component';
import { ResultMarkdownBlockComponent } from './components/result-markdown-block/result-markdown-block.component';
import { ResultRichTextBlockComponent } from './components/result-rich-text-block/result-rich-text-block.component';
import { ResultRichTextEmojiComponent } from './components/result-rich-text-emoji/result-rich-text-emoji.component';
import { ResultRichTextLinkComponent } from './components/result-rich-text-link/result-rich-text-link.component';
import { ResultRichTextListComponent } from './components/result-rich-text-list/result-rich-text-list.component';
import { ResultRichTextPersonComponent } from './components/result-rich-text-person/result-rich-text-person.component';
import { ResultRichTextPreformattedComponent } from './components/result-rich-text-preformatted/result-rich-text-preformatted.component';
import { ResultRichTextQuoteComponent } from './components/result-rich-text-quote/result-rich-text-quote.component';
import { ResultRichTextSectionElementsComponent } from './components/result-rich-text-section-elements/result-rich-text-section-elements.component';
import { ResultRichTextSectionComponent } from './components/result-rich-text-section/result-rich-text-section.component';
import { ResultRichTextTextComponent } from './components/result-rich-text-text/result-rich-text-text.component';
import { ResultSnippetComponent } from './components/result-snippet/result-snippet.component';
import { ResultSubViewComponent } from './components/result-sub-view/result-sub-view.component';
import { ResultSubtitleComponent } from './components/result-subtitle/result-subtitle.component';
import { ResultTitleComponent } from './components/result-title/result-title.component';
import { PreviewResultsComponent } from './components/results-preview/preview-results.component';
import { ShortResultResourceComponent } from './components/short-result-resources/short-result-resource/short-result-resource.component';
import { ShortResultResourcesComponent } from './components/short-result-resources/short-result-resources.component';
import { SiteLinkComponent } from './components/site-link/site-link.component';
import { PathShortenerPipe } from './components/stack-viewer/path-shortener.pipe';
import { StackViewerComponent } from './components/stack-viewer/stack-viewer.component';
import { StaticResultItemComponent } from './components/static-result-item/static-result-item.component';
import { StaticSearchItemComponent } from './components/static-search-item/static-search-item.component';
import { SuggestionsItemComponent } from './components/suggestions-item/suggestions-item.component';
import { SummaryPopupComponent } from './components/summary-popup/summary-popup.component';
import { SyncingStateComponent } from './components/syncing-state/syncing-state.component';
import { TimeActionItemComponent } from './components/time-action-item/time-action-item.component';
import { VisitItemComponent } from './components/visit-item/visit-item.component';
import { ResultAttachmentService } from './services/result-attachment.service';
import { DropFileComponent } from './components/drop-file/drop-file.component';
import { AppViewItemComponent } from '../results-views/app/app-view-item/app-view-item.component';
const components = [
  ResultBadgeComponent,
  BrowserBookmarkItemComponent,
  ResultBulletComponent,
  ResultBulletPartComponent,
  ResultItemComponent,
  ResultFolderComponent,
  ResultSubtitleComponent,
  ResultTitleComponent,
  ResultsHeaderComponent,
  ResultAttachmentComponent,
  ResultAttachmentPopupComponent,
  SiteLinkComponent,
  ParamSelectionsComponent,
  ParamSelectionsItemComponent,
  BrowserTabItemComponent,
  VisitItemComponent,
  ErrorItemComponent,
  CalcResultItemComponent,
  EmbedItemComponent,
  StackViewerComponent,
  PathShortenerPipe,
  ConnectPcComponent,
  RecentSearchItemComponent,
  LocalActionsItemComponent,
  CreateGoLinkItemComponent,
  SyncingStateComponent,
  GoToItemComponent,
  QueryItemComponent,
  SuggestionsItemComponent,
  FilesViewItemComponent,
  MailViewItemComponent,
  PeopleViewItemComponent,
  ResultSnippetComponent,
  ResultCodeBlockComponent,
  ResultRichTextBlockComponent,
  ResultRichTextSectionComponent,
  ResultRichTextPersonComponent,
  ResultRichTextLinkComponent,
  ResultRichTextEmojiComponent,
  ResultRichTextTextComponent,
  ResultRichTextListComponent,
  ResultRichTextSectionElementsComponent,
  ResultRichTextPreformattedComponent,
  ResultRichTextQuoteComponent,
  ResultAnnotationComponent,
  ResultSubViewComponent,
  StaticResultItemComponent,
  DragAndDropComponent,
  DropFileComponent,
  SummaryPopupComponent,
  StaticSearchItemComponent,
  GalleryViewComponent,
  FeedbackPopupComponent,
  FeedbackReasonOptionsComponent,
  AnswerFeedbackComponent,
  ResultsAnswerItemComponent,
  ShortResultResourcesComponent,
  ShortResultResourceComponent,
  GalleryGroupComponent,
  RelevantPeopleItemComponent,
  ResultMarkdownBlockComponent,
  AnswerActionsComponent,
  PreviewResultsComponent,
  TimeActionItemComponent,
  ResourcePanelComponent,
  ResourcePanelPopupComponent,
  ResourceRedirectorComponent,
  AppViewItemComponent,
];

const directives = [CustomResourcePanelDirective];

const modules = [NgxCodeJarComponent, PreviewModule, NgxJsonViewerModule, AnswerCodeHeaderModule];
const providers = [ResultAttachmentService, ChatResourcesService];
@NgModule({
  declarations: [...components, ...directives],
  imports: modules,
  exports: [...components, ...directives, ...modules],
  providers: providers,
})
export class ResultsModule {}
